// extracted by mini-css-extract-plugin
export default {"link":"Link_link__DLONq","lightBorder":"Link_lightBorder__2Qg3k"};